import React, { Component, ReactNode } from 'react';
import CoverProductDescriptionContent from '../CoverProductDescriptionContent/CoverProductDescriptionContent';

/**
 * React component.
 *
 */
export default class CoverProductDescription extends Component {
	/**
	 * React render method.
	 *
	 * @returns React node.
	 */
	public render(): ReactNode {
		return <CoverProductDescriptionContent />;
	}
}
